/**
 * @file 上方标题，包含展示/隐藏资产按钮和跳转到历史页的按钮
 */
import { Button } from '@bfe/moly';
import { EyeonIcon, EyeoffIcon } from '@bfe/moly-icons';
import { useFm } from '@web3/base-hooks';
import { useParams } from '@web3/base-hooks';
import { appPath } from '@web3/base-utils';

import styles from './index.module.scss';

interface Props {
  showAsset: boolean;
  onChangeShowAsset: (v: boolean) => void;
}

export const Title = (props: Props) => {
  const { showAsset, onChangeShowAsset } = props;
  const fm = useFm();
  const { locale } = useParams();
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.text}>{fm('staking_my_investments')}</div>
        <div className={styles.controlAsset}>
          {showAsset && (
            <EyeonIcon
              className={styles.icon}
              onClick={() => onChangeShowAsset(false)}
            />
          )}
          {!showAsset && (
            <EyeoffIcon
              className={styles.icon}
              onClick={() => onChangeShowAsset(true)}
            />
          )}
        </div>
      </div>
      <div className={styles.right}>
        <Button
          variant="secondary"
          size="small"
          onClick={() => {
            if (window.top) {
              window.top.location.href = `/${locale}${appPath}/history`;
            }
          }}
        >
          {fm('history')}
        </Button>
      </div>
    </div>
  );
};
